export default __webpack_public_path__ + "static/media/Reservations.7cc33d07.png";